import store from '@/store/store'
import { RawLocation, Route } from 'vue-router'
import Vue from 'vue'

export default async function(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
) {
    const applyLocale = window.localStorage.getItem('applyLocale') || null
    if (!to.meta.doNotResetLocale && applyLocale) {
        window.localStorage.removeItem('applyLocale')

        // @ts-ignore
        const meLocale = (store.state.user && store.state.user.me.locale) || null

        if (!meLocale && applyLocale !== 'fr') {
            window.location.href = to.fullPath
            return next(false)
        }
    }

    return next()
}
